import { showPopups } from "./showPopup";

/**
 * Sync contact verify notification from refresh, market status, or uidata api responses
 */
export const syncContactVerifyNotifyFromStatus = (
  responseData,
  setAuth,
  infoPopupHandlers,
) => {
  if (responseData?.contact_verify_notify) {
    setAuth((prev) => (prev?.contact_verify_notify ? prev : { ...prev, contact_verify_notify: true }));
  }
  if (infoPopupHandlers) {
    showPopups(responseData, infoPopupHandlers);
  }
};

/**
 * Sync promo notification popup data from uidata api responses.
 */
export const syncPromoNotifFromUidata = (responseData, setNotifData, setShowNotif) => {
  if (!setNotifData || !setShowNotif) return;
  if (responseData?.notif === true && responseData?.notif_data) {
    setNotifData(responseData.notif_data);
    setShowNotif(true);
  }
};

/**
 * Sync contact-verify, promo notif, and info_alert popup from uidata/status responses.
 */
export const syncUidataNotifyFlags = (
  responseData,
  setAuth,
  setNotifData,
  setShowNotif,
  infoPopupHandlers,
) => {
  syncContactVerifyNotifyFromStatus(responseData, setAuth, infoPopupHandlers);
  syncPromoNotifFromUidata(responseData, setNotifData, setShowNotif);
};
